import React, { Component } from 'react';
import { object, bool, string, func, number, shape, array } from 'prop-types';
import LoadingIndicator from '../../../LoadingIndicator/LoadingIndicator';
import ReportCard from './ReportCard';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as reportActionCreators from '../ReportActions';

class ReportCardContainer extends Component {
  static propTypes = {
    userReportViewer: bool,
    report: object,
    showSlideout: func,
    location: object,
    history: object,
    actions: object,
    userId: string,
    userEmail: string,
    groupId: string,
    launchDarklyFeatureFlags: object,
    reportUrl: string,
    reportBulkSelect: func,
    reportBulkSelectPopular: func,
    popularFilter: bool,
    isPopularSelected: bool,
    userCanSelect: bool
  };

  constructor(props) {
    super(props);
    this.reportClick = this.reportClick.bind(this);
    this.vizClick = this.vizClick.bind(this);
    this.selectForEditClick = this.selectForEditClick.bind(this);
    this.getIsSelected = this.getIsSelected.bind(this);
  }

  reportClick(e) {
    if (this.props.report.isVisualization && this.props.report.thumbnail) {
      this.vizClick(e);
    } else {
      let url = this.props.reportUrl;
      this.props.history.push({
        pathname: url,
        state: { history: this.props.location.pathname }
      });
    }
  }

  // Because the report card itself has a click event
  // stop propagation for the viz link
  vizClick(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.props.actions.selectReport(this.props.report);
  }

  selectForEditClick() {
    this.props.reportBulkSelect(this.props.report);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.report.isVisualization &&
      !nextProps.report.thumbnail &&
      !nextProps.report.thumbnailLoading &&
      !nextProps.report.thumbnailLoaded
    ) {
      this.props.actions.getReportVisualization(this.props.report.id);
    }
  }

  componentDidMount() {
    if (this.props.report.isVisualization) {
      this.props.actions.getReportVisualization(this.props.report.id);
    }
  }

  getIsSelected() {
    if (this.props.popularFilter) {
      return this.props.isPopularSelected || false;
    } else {
      return this.props.report?.selectedForEdit || false;
    }
  }

  render() {
    if (!this.props.report) {
      return <LoadingIndicator />;
    }
    const report = this.props.report;
    return (
      <ReportCard
        userReportViewer={this.props.userReportViewer}
        userCanSelect={this.props.userCanSelect}
        key={report.id}
        id={report.id}
        url={this.props.reportUrl}
        category={report.type.name}
        title={report.name}
        description={report.description}
        launchDarklyFeatureFlags={this.props.launchDarklyFeatureFlags}
        modified={report.lastModified}
        modifiedBy={`${report.lastModifiedBy.firstName} ${report.lastModifiedBy.lastName}`}
        isFavorite={report.isFavorite}
        isVisualization={report.isVisualization}
        scopeName={report.scope.name}
        categoryId={Number(report.type.id)}
        scopeCode={report.scope.code}
        showSlideout={this.props.showSlideout}
        thumbnail={report.thumbnail}
        reportClick={this.reportClick}
        reportSelectClick={this.selectForEditClick}
        onSelectPopular={this.props.onSelectPopular}
        selected={this.getIsSelected()}
        popularFilter={this.props.popularFilter}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(reportActionCreators, dispatch)
});

export default withRouter(connect(null, mapDispatchToProps)(ReportCardContainer));
